import { format } from 'date-fns';

// Currency formatter
export const formatCurrency = (amount, currency = 'BDT') => {
  if (currency === 'BDT') {
    return `৳${new Intl.NumberFormat('en-BD', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount)}`;
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

// Date formatters
export const formatDate = (date, formatString = 'MMM dd, yyyy') => {
  if (!date) return '';
  const dateObj = date.toDate ? date.toDate() : new Date(date);
  return format(dateObj, formatString);
};

export const formatDateShort = (date) => {
  return formatDate(date, 'MM/dd/yy');
};

export const formatDateLong = (date) => {
  return formatDate(date, 'MMMM dd, yyyy');
};

// Number formatters
export const formatNumber = (number, decimals = 0) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number);
};

export const formatPercentage = (value, total) => {
  if (!total || total === 0) return '0%';
  const percentage = (value / total) * 100;
  return `${Math.round(percentage)}%`;
};

// Text formatters
export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
